angular.module('impactx.scheduler').controller('SchedulerTaskCtrl', [
    '$scope',
    'dataGen',
    SchedulerTaskCtrl]);

function SchedulerTaskCtrl($scope, dataGen) {
    var self = this;

    self.getTaskData = function (className, setOriginalId) {
        var originalSCHId = self.task.id;
        return dataGen.getData({}, {
            className: className
        }, '/scheduler/task/view', null, true).then(function (data) {
            if (impactX.isDefined(data, 'data')) {
                self.task = data.data;
                if (setOriginalId) {
                    self.task.id = originalSCHId;
                }
                self.task.selected = true;
                return self.task;
            }
        });
    };

    $scope.$watch(function () {
        return impactX.isDefined($scope, 'parameterData.$invalid');
    }, function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
            self.task.invalid = newValue;
            $scope.invalidTask = newValue;
        }
    }, true);
}